import type { Template } from "@/types";

export const LA_06_H4_V2: Template[] = [
    {
        id: "la-06-h4v2-01",
        name: "LA 01 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 118, y: 50, width: 440, height: 271, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 329, width: 142, height: 104, rotation: 0, imageRotation: 0 },
            { id: "3", x: 268, y: 329, width: 141, height: 104, rotation: 0, imageRotation: 0 },
            { id: "4", x: 417, y: 329, width: 141, height: 104, rotation: 0, imageRotation: 0 },
            { id: "5", x: 740, y: 50, width: 271, height: 382, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 50, width: 271, height: 382, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-02",
        name: "LA 02 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 126, y: 45, width: 424, height: 251, rotation: 0, imageRotation: 0 },
            { id: "2", x: 126, y: 303, width: 208, height: 135, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 303, width: 208, height: 135, rotation: 0, imageRotation: 0 },
            { id: "4", x: 865, y: 45, width: 298, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 865, y: 246, width: 146, height: 192, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 246, width: 145, height: 192, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-03",
        name: "LA 03 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 153, y: 47, width: 170, height: 230, rotation: 0, imageRotation: 0 },
            { id: "2", x: 330, y: 47, width: 183, height: 111, rotation: 0, imageRotation: 0 },
            { id: "3", x: 330, y: 165, width: 183, height: 111, rotation: 0, imageRotation: 0 },
            { id: "4", x: 153, y: 284, width: 120, height: 154, rotation: 0, imageRotation: 0 },
            { id: "5", x: 280, y: 284, width: 233, height: 154, rotation: 0, imageRotation: 0 },
            { id: "6", x: 754, y: 77, width: 519, height: 329, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-04",
        name: "LA 04 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 113, y: 37, width: 287, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 407, y: 247, width: 151, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 407, y: 37, width: 151, height: 98, rotation: 0, imageRotation: 0 },
            { id: "4", x: 407, y: 142, width: 151, height: 98, rotation: 0, imageRotation: 0 },
            { id: "5", x: 853, y: 37, width: 322, height: 202, rotation: 0, imageRotation: 0 },
            { id: "6", x: 853, y: 246, width: 322, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-05",
        name: "LA 05 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_05.png",
        size: [1352, 483],
        style: {},
        slots: [       
            { id: "1", x: 85, y: 40, width: 290, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 85, y: 246, width: 290, height: 197, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 40, width: 290, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 383, y: 246, width: 290, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 40, width: 289, height: 403, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 40, width: 289, height: 403, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-06",
        name: "LA 06 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 85, y: 40, width: 290, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 85, y: 246, width: 290, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 40, width: 289, height: 403, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 40, width: 290, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 246, width: 290, height: 198, rotation: 0, imageRotation: 0 },
            { id: "6", x: 979, y: 40, width: 289, height: 403, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-07",
        name: "LA 07 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 85, y: 40, width: 290, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 85, y: 246, width: 290, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 40, width: 289, height: 404, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 40, width: 290, height: 404, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 40, width: 289, height: 198, rotation: 0, imageRotation: 0 },
            { id: "6", x: 979, y: 246, width: 289, height: 198, rotation: 0, imageRotation: 0 }        
        ],
    },

    {
        id: "la-06-h4v2-08",
        name: "LA 08 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 35, y: 64, width: 256, height: 356, rotation: 0, imageRotation: 0 },
            { id: "2", x: 487, y: 64, width: 256, height: 356, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 64, width: 567, height: 356, rotation: 0, imageRotation: 0 },
            { id: "4", x: 298, y: 64, width: 182, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 298, y: 185, width: 182, height: 114, rotation: 0, imageRotation: 0 },
            { id: "6", x: 298, y: 306, width: 182, height: 114, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-09",
        name: "LA 09 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 35, y: 64, width: 567, height: 356, rotation: 0, imageRotation: 0 },
            { id: "2", x: 609, y: 64, width: 256, height: 356, rotation: 0, imageRotation: 0 },
            { id: "3", x: 872, y: 64, width: 256, height: 356, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1135, y: 64, width: 182, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1135, y: 185, width: 182, height: 114, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1135, y: 306, width: 182, height: 114, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-10",
        name: "LA 10 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h4_v2_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 166, y: 35, width: 641, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 35, width: 154, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 815, y: 245, width: 154, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 976, y: 35, width: 211, height: 133, rotation: 0, imageRotation: 0 },
            { id: "5", x: 976, y: 175, width: 211, height: 133, rotation: 0, imageRotation: 0 },
            { id: "6", x: 976, y: 315, width: 211, height: 133, rotation: 0, imageRotation: 0 }
        ],
    }
];